module.exports = __webpack_public_path__ + "static/media/IR.7b764440.svg";